"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import type { ChallengeZoneGame } from "./types";
import type { Labels } from "@/lib/labels/types";
interface GameCardProps {
  game: ChallengeZoneGame;
  labels: Labels["challengeZone"];
  onClick: () => void;
  /** Whether to render at compact sidebar size */
  compact?: boolean;
}

/** Color config per game type */
const TYPE_STYLES: Record<string, {
  badgeBg: string;
  badgeText: string;
  ctaBg: string;
  label: string;
}> = {
  poll: {
    badgeBg: "bg-accent/20",
    badgeText: "text-accent",
    ctaBg: "bg-gradient-to-r from-primary to-accent",
    label: "Poll"
  },
  "classic-quiz": {
    badgeBg: "bg-success/20",
    badgeText: "text-success",
    ctaBg: "bg-success",
    label: "Quiz"
  },
  "personality-quiz": {
    badgeBg: "bg-info/20",
    badgeText: "text-info",
    ctaBg: "bg-info",
    label: "Personality"
  }
};
function formatCount(count: number): string {
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  }
  return String(count);
}
export function GameCard(t0) {
  const $ = _c(24);
  const {
    game,
    labels,
    onClick,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const style = TYPE_STYLES[game.type] || TYPE_STYLES["classic-quiz"];
  const ctaLabel = labels[game.ctaKey];
  const t2 = labels[game.participationKey];
  let t3;
  if ($[0] !== game.participationCount || $[1] !== t2) {
    t3 = t2.replace("{count}", formatCount(game.participationCount));
    $[0] = game.participationCount;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const participationLabel = t3;
  const imageHeight = compact ? "h-[90px]" : "h-[110px]";
  const t4 = `bg-card rounded-xl overflow-hidden cursor-pointer ${!game.image ? "p-3.5 flex flex-col justify-between h-full" : ""}`;
  let t5;
  if ($[3] !== compact || $[4] !== ctaLabel || $[5] !== game.image || $[6] !== game.isHot || $[7] !== game.title || $[8] !== imageHeight || $[9] !== labels.hot || $[10] !== participationLabel || $[11] !== style.badgeBg || $[12] !== style.badgeText || $[13] !== style.ctaBg || $[14] !== style.label) {
    t5 = game.image ? <><div className={`${imageHeight} relative overflow-hidden`}><Image src={game.image} alt={game.title} fill={true} sizes={compact ? "300px" : "256px"} className="object-cover" unoptimized={true} /><div className="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-card to-transparent" />{game.isHot && <div className="absolute top-2 right-2"><span className="bg-gradient-to-r from-warning to-error backdrop-blur-sm text-white px-2.5 py-1 rounded-md text-[9px] font-bold tracking-wide uppercase">{labels.hot}</span></div>}<div className="absolute top-2 left-2"><span className={`${style.badgeBg} backdrop-blur-sm text-white px-2.5 py-1 rounded-md text-[9px] font-bold tracking-wide uppercase`}>{style.label}</span></div></div><div className="p-2.5 pb-3"><p className="text-[13px] font-bold text-card-foreground leading-tight mb-2.5 line-clamp-2">{game.title}</p><div className="flex items-center justify-between"><span className="text-[10px] text-muted-foreground font-semibold">{participationLabel}</span><span className={`${style.ctaBg} text-white px-3 py-1 rounded-lg text-[10px] font-bold`}>{ctaLabel}</span></div></div></> : <><div><div className="flex items-center gap-1.5 mb-2"><span className={`${style.badgeBg} ${style.badgeText} px-2.5 py-1 rounded-md text-[10px] font-bold tracking-wide uppercase`}>{style.label}</span>{game.isHot && <span className="bg-gradient-to-r from-warning to-error text-white px-2.5 py-1 rounded-md text-[10px] font-bold tracking-wide uppercase">{labels.hot}</span>}</div><p className="text-[13px] font-bold text-card-foreground leading-tight line-clamp-2">{game.title}</p></div><div className="flex items-center justify-between mt-3"><span className="text-[10px] text-muted-foreground font-semibold">{participationLabel}</span><span className={`${style.ctaBg} text-white px-3 py-1 rounded-lg text-[10px] font-bold`}>{ctaLabel}</span></div></>;
    $[3] = compact;
    $[4] = ctaLabel;
    $[5] = game.image;
    $[6] = game.isHot;
    $[7] = game.title;
    $[8] = imageHeight;
    $[9] = labels.hot;
    $[10] = participationLabel;
    $[11] = style.badgeBg;
    $[12] = style.badgeText;
    $[13] = style.ctaBg;
    $[14] = style.label;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== onClick || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className={t4} onClick={onClick}>{t5}</div>;
    $[16] = onClick;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const cardContent = t6;
  if (game.isHot) {
    let t7;
    if ($[20] !== cardContent) {
      t7 = <div className="rounded-xl p-px animate-spin-slow-bg"><div className="rounded-[11px] overflow-hidden">{cardContent}</div></div>;
      $[20] = cardContent;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    return t7;
  }
  let t7;
  if ($[22] !== cardContent) {
    t7 = <div className="rounded-xl border border-border">{cardContent}</div>;
    $[22] = cardContent;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}